"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VoucherForm = function VoucherForm(props) {
  var validation = function validation(values) {
    var errors = {};
    if (!values.orderId) {
      errors.orderId = 'Order is required';
    }
    if (!values.purchaseEmail) {
      errors.purchaseEmail = 'Purchase Email is required';
    }
    return errors;
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: function onSubmit(values) {
      return props.onSubmit(values);
    },
    validate: validation,
    initialValues: {
      orderId: props.orderId ? props.orderId : '',
      purchaseEmail: props.purchaseEmail ? props.purchaseEmail : ''
    },
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
        style: {
          marginBottom: '30px'
        }
      }, "Product Voucher Search"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card ".concat(_style["default"].form)
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Please enter your Order ID Number and the Email used for the purchase."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].horizontal
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "4 Digit ID Number from the order"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "orderId",
        component: _cccisdFormik.CccisdInput,
        label: "Order ID Number:",
        autoFocus: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Email used to purchase the license(s)"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "purchaseEmail",
        component: _cccisdFormik.CccisdInput,
        label: "Purchase E-mail:"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Search"))))));
    }
  });
};
var _default = exports["default"] = VoucherForm;